import Slider from 'react-slick';   
import  './FleetTwentyFiveSlide.css';
const PrevArrow = (props) => (
  <button {...props} className="slick-prev">
    <img src="/img/rentshield/claims_arrow_left.svg" alt="Previous" width="48" height="48" />
  </button>
);

const NextArrow = (props) => (
  <button {...props} className="slick-next">
    <img src="/img/rentshield/claims_arrow_right.svg" alt="Next" width="48" height="48" />
  </button>
);

const FleetFiveSlide = ()=>{

// START cards
  // const cards = [
  //   { 
  //     id: 1, 
  //     image: '/img/Fleet/car_grad_1.svg',
  //     heading: 'Streamlined Fleet Management', 
  //     text: 'Manage up to 25 vehicles with an integrated platform that simplifies reservations, compliance tracking, and logistics' 
  //   },
  //   { 
  //     id: 2, 
  //     image: '/img/Fleet/analytics_grad_1.svg',
  //     heading: 'Automation for Operational Efficiency', 
  //     text: 'Reduce administrative workload with AI-powered automation for guest interactions, payments, and fleet scheduling.' 
  //   },
  //   { 
  //     id: 3, 
  //     image: '/img/Fleet/flow_grad_1.svg',
  //     heading: 'Scalable Insurance Coverage', 
  //     text: 'RentShield™ offers adaptable coverage, whether for individual rentals or entire fleets, ensuring optimal protection at every stage of growth.' 
  //   },
  //   { 
  //     id: 4, 
  //     image: '/img/Fleet/loaction_grad_1.svg',
  //     heading: 'Multi-Location Optimization', 
  //     text: 'Allocate vehicles strategically, optimize delivery logistics, and adjust pricing based on location demand.' 
  //   },
  //   { 
  //     id: 5, 
  //     image: '/img/Fleet/calendar_grad_1.svg',
  //     heading: 'Revenue Insights & Utilization Metrics', 
  //     text: 'Monitor vehicle availability, track revenue trends, and adjust pricing dynamically to increase profitability.' 
  //   },
  //   { 
  //     id: 6, 
  //     image: '/img/Fleet/conversation_grad_1.svg',
  //     heading: 'AI-Driven Guest Communication', 
  //     text: 'Reduce customer service workload with Rent.AI™, which automates inquiries, booking modifications, and issue resolution.' 
  //   },

  //  ];
// END cards


// START slick
const settings = {
  slidesToShow: 5,
  slidesToScroll: 1,
  margin: 30,
  autoplay: true,
  autoplaySpeed: 2000,

  // autoplaySpeed: 0,  // No delay between scrolls
  // speed: 4000,  // Smooth continuous movement
  // cssEase: 'linear',

  loop: true,
  dots: false,
  arrows: false,
  focusOnSelect: true,
  centerPadding: '30px',
  prevArrow: <PrevArrow />,
  nextArrow: <NextArrow />,
  responsive: [
    {
      breakpoint: 1480,
      settings: {
        slidesToShow: 4, // Correcting the key to 'slidesToShow'
        infinite: true,
        centerPadding: "30px",
        margin: 30,
      },
    },
    {
      breakpoint: 1280,
      settings: {
        slidesToShow: 4, // Correcting the key to 'slidesToShow'
        infinite: true,
        centerPadding: "30px",
        margin: 30,
      },
    },
    {
      breakpoint: 1199,
      settings: {
        slidesToShow: 3, // Correcting the key to 'slidesToShow'
        infinite: true,
        margin: 30,
      },
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 3, // Correcting the key to 'slidesToShow'
        margin: 20,
      },
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 2, // Correcting the key to 'slidesToShow'
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2, // Correcting the key to 'slidesToShow'
      },
    },
    {
      breakpoint: 575,
      settings: {
        slidesToShow: 2, // Correcting the key to 'slidesToShow'
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1, // Correcting the key to 'slidesToShow'
        centerPadding: "30px",
      },
    },
  ],
};
// END slick

    return(
        <>
            {/* START fleetTwentyFiveSliderMain */}
            <section className="fleetTwentyFiveSliderMain">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-12">
                            <div className="fleetTwentyFiveSliderHead">
                                <h2>Mid-Sized Fleets Choose Rentid</h2>
                                <p>Unlocking Growth and Efficiency</p>
                            </div>
                        </div>
                    </div>
                  </div>
                  
                  <div className='row justify-content-center'>
                    <div className='col-lg-12 col-md-12 col-sm-12 col-12'>
                        <Slider {...settings}>  
                            <div className="item">
                              <div className="fleetTwentyFiveSliderDetail">
                                <img className="img-fluid" src="/img/Fleet/car_grad_1.svg" alt="Streamlined Fleet Management" />
                                <h3>Streamlined Fleet<br/> Management</h3>
                                <p>Manage up to 25 vehicles with an<br/> integrated platform that simplifies<br/> reservations, 
                                compliance tracking,<br/> and logistics</p>
                              </div>
                            </div>
                            <div className="item">
                              <div className="fleetTwentyFiveSliderDetail">
                                <img className="img-fluid" src="/img/Fleet/analytics_grad_1.svg" alt="Automation for Operational Efficiency" />
                                <h3>Automation for<br/> Operational Efficiency</h3>
                                <p>Reduce administrative workload with<br/> AI-powered automation for guest<br/> interactions, 
                                payments, and fleet<br/> scheduling.</p>
                              </div>
                            </div>
                            <div className="item">
                              <div className="fleetTwentyFiveSliderDetail">
                                <img className="img-fluid" src="/img/Fleet/flow_grad_1.svg" alt="Scalable Insurance Coverage" />
                                <h3>Scalable Insurance<br/> Coverage</h3>
                                <p>RentShield™ offers adaptable<br/> coverage, whether for individual<br/> rentals 
                                or entire fleets, ensuring<br/> optimal protection at every stage of<br/> growth.</p>
                              </div>
                            </div>
                            <div className="item">
                              <div className="fleetTwentyFiveSliderDetail">
                                <img className="img-fluid" src="/img/Fleet/loaction_grad_1.svg" alt="Multi-Location Optimization" />
                                <h3>Multi-Location<br/> Optimization</h3>
                                <p>Allocate vehicles strategically,<br/> optimize delivery logistics, and adjust<br/> pricing 
                                based on location demand.</p>
                              </div>
                            </div>
                            <div className="item">
                              <div className="fleetTwentyFiveSliderDetail">
                                <img className="img-fluid" src="/img/Fleet/calendar_grad_1.svg" alt="Revenue Insights & Utilization Metrics" />
                                <h3>Revenue Insights &<br/> Utilization Metrics</h3>
                                <p>Monitor vehicle availability, track<br/> revenue trends, and adjust pricing<br/> dynamically 
                                to increase profitability.</p>
                              </div>
                            </div>
                            <div className="item">
                              <div className="fleetTwentyFiveSliderDetail">
                                <img className="img-fluid" src="/img/Fleet/conversation_grad_1.svg" alt="AI-Driven Guest Communication" />
                                <h3>AI-Driven Guest<br/> Communication</h3>
                                <p>Reduce customer service workload<br/> with Rent.AI™, which automates<br/> inquiries, 
                                booking modifications, and<br/> issue resolution.</p>
                              </div>
                            </div>
                        </Slider> 
      
                    </div>
                  </div>  

                  {/* <div className="fleetTwentyFiveSlider">
                      <div className="carousel-container mt-2">
                          <div className="carousel">
                                <div className="carousel-track ">
                                  {cards.map((card) => (
                                    <div key={card.id} className="fleetTwentyFiveSliderDetail">
                                      <img src={card.image} alt={card.heading1} className="img-fluid" />
                                      <h3>{card.heading}</h3>
                                      <p>{card.text}</p>
                                    </div>
                                  ))}
                                </div> 
                                <div className="carousel-track ">
                                  {cards.map((card) => (
                                    <div key={`duplicate-${card.id}`} className="fleetTwentyFiveSliderDetail">
                                      <img src={card.image} alt={card.heading1} className="img-fluid" />
                                      <h3>{card.heading}</h3>
                                      <p>{card.text}</p>
                                    </div>
                                  ))}
                                </div>
                          </div>
                      </div>
                  </div> */}
            </section>
            {/* END fleetTwentyFiveSliderMain */}
        </>
    )
}

export default FleetFiveSlide;